import { Box, Flex, Icon, useBreakpointValue } from '@chakra-ui/react';
import React from 'react';
import { FiPlay } from 'react-icons/fi';
import Image from '../Image';
import StyledLink from '../StyledLink';
import Text from '../Text';

var PostEntry = function PostEntry(props) {
  var date = props.date,
      description = props.description,
      image = props.image,
      _props$isCompact = props.isCompact,
      isCompact = _props$isCompact === void 0 ? false : _props$isCompact,
      title = props.title,
      uri = props.uri;
  return /*#__PURE__*/React.createElement(Flex, {
    direction: {
      base: 'column',
      lg: 'row'
    },
    align: "center",
    position: "relative",
    justify: "flex-start"
  }, /*#__PURE__*/React.createElement(Box, {
    spacing: 4,
    justify: "center",
    position: "relative",
    p: 8,
    pr: {
      base: 8,
      lg: '9rem'
    },
    borderColor: "primary.500",
    borderWidth: "1px",
    borderStyle: "solid",
    maxWidth: isCompact ? '450px' : '100%',
    width: isCompact ? '100%' : {
      base: '100%',
      lg: '50%'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    textVariant: "h3",
    fontWeight: "900",
    mb: 1
  }, title), date ? /*#__PURE__*/React.createElement(Text, {
    fontSize: "sm",
    mb: 2
  }, date) : null, /*#__PURE__*/React.createElement(Text, {
    mb: 2
  }, description), /*#__PURE__*/React.createElement(StyledLink, {
    to: uri,
    display: "flex",
    w: "fit-content"
  }, /*#__PURE__*/React.createElement(Text, {
    mr: 2,
    fontWeight: "bold"
  }, "Lire l'article"), /*#__PURE__*/React.createElement(Icon, {
    as: FiPlay,
    boxSize: 30,
    color: "primary.500"
  }))), !isCompact && /*#__PURE__*/React.createElement(Image, {
    width: {
      base: '90%',
      lg: '600px'
    },
    mt: {
      base: -4,
      lg: 0
    },
    height: {
      base: 'auto',
      lg: '110%'
    },
    position: {
      base: 'relative',
      lg: 'absolute'
    },
    right: {
      base: 0,
      lg: '-75px'
    },
    top: {
      base: 0,
      lg: '-10%'
    },
    image: image,
    ratio: useBreakpointValue({
      base: 1.5,
      sm: 2,
      md: 1.5
    }),
    zIndex: "hide"
  }));
};

export default PostEntry;